import { ReactElement } from 'react';

import { SkeletonFill } from '@/components';

// import { useCreditsRowsPerPage } from '../store/use-credits-pagination-store';

import { SkeletonCreditsTableRow } from './SkeletonCreditsTableRow';

export const CreditsListLoading = (): ReactElement => {
  // const creditsRowsPerPage = useCreditsRowsPerPage();

  return (
    <SkeletonFill count={9}>
      <SkeletonCreditsTableRow />
    </SkeletonFill>
  );
};
